import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import session from './modules/session'
import account from './modules/account'
import user from './modules/user'
import role from './modules/role'
import tenant from './modules/tenant'

import asdcom_app from './modules/asdcom.app'
import asdcom_correspondence from './modules/asdcom.correspondence'
import asdcom_account from './modules/asdcom.account'
import asdcom_session from './modules/asdcom.session'
 
import vcponlineok from './modules/vcponlineok'
 
 Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    //
  },
  mutations: {
    //
  },
  actions: {

  },
  modules: {
    app,
    session,
    account,
    user,
    role,
    tenant,
    
    asdcom:{
      namespaced:true,
      modules:{
        app: asdcom_app,
        correspondence: asdcom_correspondence,
        session: asdcom_session,
        account: asdcom_account,
      }
    },
    vcponlineok,

  }
})

export default store
